import TagManager from 'react-gtm-module';
import getEnv from '../../../services/util/getEnv';
export const gtmTag = (event, payload) => {
  const tagManagerArgs = {
    gtmId: getEnv("REACT_APP_GTM_ID"),
    dataLayer: {
      event,
      ...payload
    }
  };
  TagManager.dataLayer(tagManagerArgs);
};

export const onboardingGtmTag = (event) => {
  /* NEW GTM REQUEST */
  const roles = [
    localStorage.getItem('userFullStackNodeReact'),
    localStorage.getItem('userFullStackPythonReact'),
    localStorage.getItem('userFullStackPythonDjango'),
    localStorage.getItem('userFullStackRubyFrontend'),
    localStorage.getItem('userFullStackPHPFrontend'),
    localStorage.getItem('userFullStackGolangFrontend'),
    localStorage.getItem('userFullStackJavaFrontend'),
    localStorage.getItem('userDevOps'),
    localStorage.getItem('userReactNative'),
    localStorage.getItem('userAndroid'),
    localStorage.getItem('userSwift'),
    localStorage.getItem('userMachineLearning')
  ].filter(r => (r && r !== ''));

  const currentQuery = queryString.parse(window.location.search);
  const s_param = currentQuery.s || '';
  const agentData = JSON.parse(localStorage.getItem('agentDataInfo')) || {};
  const userEnglishSkill = localStorage.getItem('userEnglishSkill') || '';
  const userEnggExperience = localStorage.getItem('userEnggExperience') || '';
  const userFullAvailability = localStorage.getItem('userFullAvailability') || '';
  const readyToTakeChallenge = localStorage.getItem('userReadyToTakeChallenge') || '';
  const tagManagerArgs = {
    gtmId: getEnv("REACT_APP_GTM_ID"),
    dataLayer: {
      event,
      roles,
      userEmail: localStorage.getItem('userEmail'),
      answer: agentData.quizAnswer,
      country_name: agentData.country_name,
      country_code: agentData.country_code,
      s_param,
      userEnglishSkill,
      userEnggExperience,
      userFullAvailability,
      readyToTakeChallenge,
      enhanced_conversion_data: {
        email: localStorage.getItem('userEmail'),
        maxNumAnswer: agentData.quizAnswer,
        userEnglishSkill,
        userEnggExperience,
        readyToTakeChallenge
      }
    }
  };

  TagManager.dataLayer(tagManagerArgs);
};
